import type * as lazyIndex from "./lazyIndex";
import { LazyBootModule, LazyAction } from "owa-bundling-light";

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(() => import(/* webpackChunkName: "CalendarPreBoot" */ "./lazyIndex"), { name: "CalendarPreBoot" });

export const lazyGetCalendarPreBootstrap: LazyAction<typeof lazyIndex.getCalendarPreBootstrap, typeof lazyModule> = new LazyAction(lazyModule, m => m.getCalendarPreBootstrap);
